import path from 'node:path'
import type { ResolvedBetterstartConfig } from '@cli-types/core-engine/config.js'
import { resolveCliAssetPath } from '@cli-utils/paths.js'
import fs from 'fs-extra'

export function copySchemaMetaschema(cwd: string, config: ResolvedBetterstartConfig): string[] {
  const created: string[] = []
  const srcPath = resolveCliAssetPath('shared-assets', 'react-admin', 'schema.json')
  const destPath = path.resolve(cwd, config.paths.schemas, 'schema.json')

  if (fs.existsSync(srcPath) && !fs.existsSync(destPath)) {
    fs.ensureDirSync(path.dirname(destPath))
    fs.copyFileSync(srcPath, destPath)
    created.push(path.join(config.paths.schemas, 'schema.json'))
  }

  return created
}
